<template>
  <b-tabs>
    <b-alert variant="success" :show="isEdit" dismissible>Votre demande de modification a été prise en compte</b-alert>
    <b-tab :title="$t('booking.show.title.summary')" class="content-centered">
      <div class="row bottom-large">

        <div v-if="stateFormation" class="col-12 col-md-12 text-left bottom-small">
          <b-alert show variant="warning">
            <span><i class="fas fa-exclamation-triangle"></i></span>
            <span class="alert-annul">Si vous souhaitez annuler ou modifier votre réservation merci de contacter : <b>reservation@groupebba-bma.com</b></span>
          </b-alert>
        </div>

        <div class="col-12 col-md-6 request-type summary bottom-small">
          <h4>{{ bookingType }}</h4>
        </div>

        <div class="col-12 col-md-6 text-right booking-number bottom-small">
          <div v-if="booking.ref" class="ref">
            <span class="numberShort">n°&nbsp</span>
            <span class="value ref">{{
              booking.ref.replace("/", "&nbsp/\n")
            }}</span>
          </div>

          <div v-if="booking.hotel_booking_reference">
            <span class="numberShort">{{ $t("hotel.booking") }} n°&nbsp</span>
            <span class="value">{{ booking.hotel_booking_reference }}</span>
          </div>

          <div v-if="orderNumber">
            <span class="numberShort">{{ orderNumber.label }} n°&nbsp</span>
            <span class="value">{{ orderNumber.value }}</span>
          </div>
        </div>

        <div class="main-info col-12">
          <div class="wrapper row">
            <div class="col-12 col-xl-6 arrival-date border-bt">
              <div class="row">
                <span class="title col-7 col-md-6">
                  {{ $t("_arrival_date") }}
                </span>

                <span class="value col-5 col-md-6">
                  {{ formatDate(booking.arrival_date) }}
                </span>
              </div>
            </div>

            <div class="col-12 col-xl-6 departure-date border-bt">
              <div class="row">
                <span class="title col-7 col-md-6">
                  {{ $t("_departure_date") }}
                </span>

                <span class="value col-5 col-md-6">
                  {{ formatDate(booking.departure_date) }}
                </span>
              </div>
            </div>
          </div>

          <div class="wrapper row">
            <div class="col-12 col-xl-6 request-status border-bt">
              <div class="row">
                <span class="title col-7 col-md-6">
                  {{ $t("booking.show.main_infos.status") }}
                </span>

                <span class="value col-5 col-md-6">
                  {{ bookingStatus }}
                </span>
              </div>
            </div>

            <div
              class="col-12 col-xl-6 cancellation-deadline border-bt"
              v-if="cancellationDeadline"
            >
              <div class="row">
                <span class="title col-7 col-md-6">
                  {{ $t("booking.show.main_infos.cancellation_deadline") }}
                </span>

                <span
                  class="value col-5 col-md-6"
                  :class="cancellationDeadline.class"
                >
                  {{ cancellationDeadline.value }}
                </span>
              </div>
            </div>

            <div
              class="col-12 col-xl-6 confirmation-deadline border-bt"
              v-if="confirmationDeadline"
            >
              <div class="row">
                <span class="title col-7 col-md-6">
                  {{ $t("booking.show.main_infos.confirmation_deadline") }}
                </span>

                <span
                  class="value col-5 col-md-6 p-lg-0"
                  :class="confirmationDeadline.class"
                >
                  {{ confirmationDeadline.value }}
                </span>
              </div>
            </div>

            <div class="col-xl-6 company-contact border-bt">
              <div class="row">
                <span class="title col-7 col-md-6">
                  {{ $t("booking.show.main_infos.company_contact") }}
                </span>

                <span
                  class="value col-5 col-md-6"
                  v-if="booking.company_contact"
                >
                  {{ fullName(booking.company_contact) }}

                  <span v-if="booking.company_contact.email">
                    ({{ booking.company_contact.email }})
                  </span>
                </span>
              </div>
            </div>

            <div class="col-xl-6 bba-contact border-bt" v-if="booking.dealt_by">
              <div class="row">
                <span class="title col-7 col-md-6">
                  {{ $t("booking.show.main_infos.bba_contact") }}
                </span>

                <span class="value col-5 col-md-6">
                  {{ formatToUCFirst(booking.dealt_by.firstname) }}
                </span>
              </div>
            </div>

            <div class="col-xl-6 booking-date border-bt">
              <div class="row">
                <span class="title col-7 col-md-6">
                  {{ $t("booking.show.main_infos.booking_date") }}
                </span>

                <span class="value col-5 col-md-6">
                  {{ formatDateTime(booking.booking_date) }}
                </span>
              </div>
            </div>

            <div
              class="col-12 col-xl-6 destination border-bt"
              v-if="!isBookingComplete"
            >
              <div class="row">
                <span class="title col-7 col-md-6">
                  {{ destinationWish.label }}
                </span>

                <span class="value col-5 col-md-6">
                  {{ destinationWish.value }}
                </span>
              </div>
            </div>

            <div
              class="col-xl-6 payment-method border-bt"
              v-if="isBookingComplete && booking.payment_method"
            >
              <div class="row">
                <span class="title col-7 col-md-6">
                  {{ $t("booking.show.conditions.payment_method") }}
                </span>

                <span class="value col-5 col-md-6">
                  {{ $t(`_payment_modes.${booking.payment_method}`) }}
                </span>
              </div>
            </div>

            <div
              class="col-xl-6 payment-detail border-bt"
              v-if="isBookingComplete && booking.payment_detail"
            >
              <div class="row">
                <span class="title col-7 col-md-6">
                  {{ $t("booking.show.conditions.payment_detail") }}
                </span>

                <span class="value col-5 col-md-6">
                  {{ booking.payment_detail }}
                </span>
              </div>
            </div>

            <div
              v-if="
                isBookingComplete &&
                booking.cancellation_conditions &&
                !booking.is_online
              "
              class="col-xl-6 cancellation border-bt"
            >
              <div class="row">
                <span class="title col-7 col-md-6">
                  {{ $t("booking.show.conditions.cancellation") }}
                </span>

                <span class="value col-5 col-md-6">
                  {{ booking.cancellation_conditions }}
                </span>
              </div>
            </div>

            <div v-if="!isBookingComplete" class="col-xl-6 prority border-bt">
              <p class="row">
                <span class="title col-7 col-md-6" id="search-priority">
                  {{ $t("offline.research_priority.title") }}
                </span>

                <span
                  v-if="booking.research_priority"
                  class="value col-5 col-md-6"
                >
                  {{ $t("_by") }}
                  {{
                    $t("offline.research_priority." + booking.research_priority)
                  }}
                </span>
              </p>

              <b-tooltip target="search-priority">
                {{ $t("booking.show.search_priority.tooltip") }}
              </b-tooltip>
            </div>
          </div>

          <div
            v-if="managers && managers.count"
            class="col-xl-6 prority border-bt"
          >
            <p class="row">
              <span class="title col-7 col-md-6" id="managers">
                {{
                  $tc(
                    "booking.managersValidation.showItemTitle",
                    managers.count
                  )
                }}
              </span>

              <span>{{ managers.text }}</span>
            </p>
          </div>
        </div>
      </div>

      <prices
        v-if="isBookingComplete"
        :booking="booking"
        :anonymous="anonymous"
        class="bottom-large"
      />

      <div class="row" v-if="booking.comment_b_b_a">
        <h5 class="col-12 bottom-large" :style="{ textAlign: 'center' }">
          <span :style="{ fontWeight: 'bold' }"
            >{{ $t("_additional_information") }} :
          </span>
          {{ booking.comment_b_b_a }}
        </h5>
      </div>

      <div class="row bottom-large">
        <div :class="displayMapOrRequests ? 'col-12 col-lg-6' : 'col-12'">
          <div class="row">
            <div
              :class="
                displayMapOrRequests ? 'col-12 order-2 order-lg-1 ' : 'col-lg-6'
              "
              class="destination-complete bottom-large"
              v-if="isBookingComplete"
            >
              <h3 class="col-12 p-0">
                {{ $t("booking.show.title.destination") }}
              </h3>

              <div v-if="booking.hotel" class="col-12 hotel p-0">
                <span class="name">
                  {{ booking.hotel.name }}
                  <category :stars="booking.hotel.category" />
                </span>

                <address>
                  <div class="address1">{{ booking.hotel.address1 }}</div>

                  <div class="address2">{{ booking.hotel.address2 }}</div>

                  <div>
                    <span class="post-code"
                      >{{ booking.hotel.post_code }}
                    </span>
                    <span class="city">{{ booking.hotel.city }}</span>
                  </div>
                </address>

                <div class="tel bottom-small" v-if="booking.hotel.phone_number">
                  <span class="title">
                    {{ $t("_phone") }}
                  </span>

                  <span class="value">
                    {{ booking.hotel.phone_number }}
                  </span>
                </div>

                <div class="email bottom-small" v-if="booking.hotel.email">
                  <span class="title">
                    {{ $t("_email") }}
                  </span>

                  <span class="value">
                    <a :href="'mailto:' + booking.hotel.email">
                      {{ booking.hotel.email }}
                    </a>
                  </span>
                </div>

                <div class="website bottom-small" v-if="booking.hotel.website">
                  <span class="title">
                    {{ $t("_website") }}
                  </span>

                  <span class="value">
                    <a
                      target="_blank"
                      :href="getWebsiteUrl(booking.hotel.website)"
                    >
                      {{ booking.hotel.website }}
                    </a>
                  </span>
                </div>
              </div>
            </div>

            <div
              :class="
                displayMapOrRequests ? 'col-12 bottom-large' : 'col-lg-6 p-md-0'
              "
              class="rooms"
            >
              <h3 class="col-12 p-0">
                {{ $t("booking.show.title.rooms") }}
              </h3>

              <div class="row" v-if="!roomTypeError">
                <div
                  v-for="room in rooms"
                  :key="room.rank"
                  :class="displayMapOrRequests ? '' : 'p-0'"
                  class="col-12 travellers"
                >
                  <h5 class="title">
                    {{ $tc(`booking.show.rooms.${room.type}`, 1) | capitalise }}

                    <span v-if="room.standardType">
                      - {{ room.standardType }}
                    </span>

                    <span v-if="room.bedType">
                      &nbsp({{ $t(`offline.bedType.${room.bedType}`) }})
                    </span>
                  </h5>

                  <div v-if="room.description">
                    <div class="room-description">
                      <span
                        v-if="isViewPortMobile || isViewPortMobileSmall"
                        class="description-abstract"
                      >
                        {{ room.description | truncate(30) }}
                      </span>

                      <span v-else>
                        {{ room.description | truncate(50) }}
                      </span>

                      <b-button
                        @click="show = !show"
                        id="tooltip-button-2"
                        class="btn"
                      >
                        <i class="fas fa-question-circle white"></i>
                      </b-button>

                      <b-tooltip :show.sync="show" target="tooltip-button-2">
                        {{ room.description }}
                      </b-tooltip>
                    </div>
                  </div>

                  <div v-if="room.crsReservationKey">
                    <div class="room-reservation-number">
                      <span>
                        {{ $t("_crsReservationKey") }} : {{ room.crsReservationKey }}

                      </span>
                    </div>
                  </div>

                  <ul class="travellers-list single">
                    <li
                      v-for="traveller in room.travellers"
                      :key="traveller.id"
                      class="travellers-list"
                    >
                      <span class="traveller-name">{{ traveller.name }}</span>

                      <span v-if="traveller.contact" class="contact">
                        {{ traveller.contact }}
                      </span>
                    </li>
                  </ul>

                  <div v-if="room.price" class="travellers-room-price">
                    {{ room.price | currency }} {{ $t("_perRoomPerDay") }}
                  </div>
                </div>
              </div>

              <div v-else class="col-12">
                {{ $t("error.roomTypeError") }}
              </div>
            </div>
          </div>
        </div>

        <div class="col-12 col-lg-6" v-if="displayMapOrRequests">
          <div class="col-12 order-1 order-lg-2 map" v-if="displayMap">
            <l-map
              style="height: 350px"
              ref="imagesMap"
              class="hotelMap"
              :options="leaflet.options"
            >
              <l-tile-layer
                :url="leaflet.url"
                :attribution="leaflet.attribution"
              />
            </l-map>
          </div>

          <div v-else class="col-12">
            <div class="row requests">
              <h3 class="p-0 col-12">
                {{ $t("booking.show.title.requests") }}
              </h3>

              <ul class="p-0 col-12">
                <li class="internet border-bt">
                  <p class="row">
                    <span class="title col-8">
                      {{ $t("offline.requests.internet") }}
                    </span>

                    <span class="value col-4">
                      {{ $t("_" + booking.internet) }}
                    </span>
                  </p>
                </li>

                <li class="car-park border-bt">
                  <p class="row">
                    <span class="title col-8">
                      {{ $t("offline.requests.private_car_park") }}
                    </span>

                    <span class="value col-4">
                      {{ $t("_" + booking.private_car_park) }}
                    </span>
                  </p>
                </li>

                <li class="catering border-bt">
                  <p class="row">
                    <span class="title col-8">
                      {{ $t("offline.requests.catering") }}
                    </span>

                    <span class="value col-4">
                      {{ $t("_" + booking.restaurant) }}
                    </span>
                  </p>
                </li>

                <li class="breakfast border-bt">
                  <p class="row">
                    <span class="title col-8">
                      {{ $t("offline.requests.breakfast") }}
                    </span>

                    <span class="value col-4">
                      {{ $t("_" + booking.breakfast_included) }}
                    </span>
                  </p>
                </li>

                <li class="disabled border-bt">
                  <p class="row">
                    <span class="title col-8">
                      {{ $t("offline.requests.disabled") }}
                    </span>

                    <span class="value col-4">
                      {{ $t("_" + booking.disabled_access) }}
                    </span>
                  </p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div class="row comments bottom-large" v-if="booking.comment">
        <h3 class="col-12">
          {{ $t("booking.show.title.comments") }}
        </h3>

        <span class="col-12 value">
          {{ booking.comment }}
        </span>
      </div>

      <div class="refs bottom-large" v-if="refs.length">
        <h3 class="">
          {{ $t("booking.show.title.refs") }}
        </h3>

        <!-- <div class="col-12"> -->
        <ul class="refs-list">
          <li v-for="ref in refs" :key="ref.id" class="bottom-small">
            <!-- <p class="row"> -->
            <span class="title">{{ ref.label }}</span>

            <span class="value">{{ ref.value }}</span>
            <!-- </p> -->
          </li>
        </ul>
        <!-- </div> -->
      </div>

      <b-alert v-if="confirm.status" variant="success" show dismissible>
        {{ $t(confirm.message) }}
      </b-alert>

      <div class="actions">
        <div class="main">
          <div class="wrapper">
            <div class="btn-actions-row left">
              <span
                v-for="(def, key) in btnActions.main.left"
                v-if="def.display"
              >
                <a
                  v-if="key.match(/^download/)"
                  v-bind:href="downloadUrl(key)"
                  target="_blank"
                  :class="def.class"
                >
                  <fa v-if="def.fa" :fa-class="def.fa" />
                  <span>{{ getBtnTitle(key) | capitalise }}</span>
                </a>

                <button
                  v-else
                  :class="def.class"
                  v-b-modal="key"
                  @click="submitAction(key)"
                >
                  <fa v-if="def.fa" :fa-class="def.fa" />
                  <span class="btn-content">
                    {{ getBtnTitle(key) | capitalise }}
                  </span>
                </button>
              </span>
            </div>

            <div class="btn-actions-row right">
              <span
                v-for="(def, key) in btnActions.main.right"
                v-if="def.display"
              >
                <button
                  @click="submitAction(key)"
                  v-b-modal="key"
                  :class="alternateClass"
                >
                  <fa v-if="def.fa" :fa-class="def.fa" />
                  <span class="btn-content">
                    {{ getBtnTitle(key) | capitalise }}
                  </span>
                </button>
              </span>
            </div>
          </div>
        </div>

        <b-row class="justify-content-lg-end" v-if="!anonymous">
          <div class="col-lg-8"><hr /></div>
        </b-row>

        <div class="secondary">
          <div class="wrapper">
            <span
              v-for="(def, key) in btnActions.secondary"
              v-if="def.display"
              class="text-right secondary-button"
            >
              <a
                @click="submitAction(key)"
                v-b-modal="key"
                class="btn-actions-row"
              >
                <fa v-if="def.fa" :fa-class="def.fa" />
                <span>{{ $t(buttons[key].title) | capitalise }}</span>
              </a>
            </span>
          </div>
        </div>

        <component
          :is="modal.name"
          ref="modal"
          v-bind="modal.props"
          @ok="confirmAction"
          @submit="submitAction"
        />
      </div>
    </b-tab>

    <b-tab v-if="!isAnonymous" :title="$t('booking.show.title.actions_history')">
      <div v-if="history.items.length" class="row history-table">
        <h3>{{ $t("booking.show.title.actions_history") }}</h3>

        <b-table striped :fields="history.fields" :items="history.items" />
      </div>
    </b-tab>

    <b-tab v-if="booking.is_online && !stateFormation" title="HRS">
      <b-table striped :fields="hrs.fields" :items="hrs.items" />
    </b-tab>
  </b-tabs>
</template>

<script>
import formatter from "@/components/global/mixins/formatterMethods";
import frontofficeFrame from "@/components/frontoffice/frame";
import buttons from "@/components/frontoffice/mixins/buttons";
import category from "@/components/frontoffice/hotel/category";
import BookingModalAllow from "@/components/frontoffice/Booking/modal/allow";
import BookingModalConfirm from "@/components/frontoffice/Booking/modal/confirm";
import BookingModalDeny from "@/components/frontoffice/Booking/modal/deny";
import BookingModalCancel from "@/components/frontoffice/Booking/modal/cancel";
import BookingModalOnlineEdit from "@/components/frontoffice/Booking/modal/onlineEdit";
import BookingModalOrderNumber from "@/components/frontoffice/Booking/modal/orderNumber";
import BookingModalSendVoucher from "@/components/frontoffice/Booking/modal/sendVoucher";
import { status, getStatusTranslation } from "@/utils/bookingStatus";
import CommonApi from "@/api/commonApi";
import bookingDeadline from "@/components/frontoffice/mixins/bookingDeadline";
import { L, LMap, LMarker, LTileLayer } from "vue2-leaflet";
import "leaflet/dist/leaflet.css";
import { defaultLeaflet } from "@/conf/leaflet";
import fa from "@/components/global/icon/fontAwesome";
import roundedButton from "@/components/frontoffice/button/rounded";
import prices from "@/components/frontoffice/Booking/prices";
import viewPort from "@/conf/viewPort";
import booking from "@/lang/fr/booking";

export default {
  components: {
    frontofficeFrame,
    BookingModalCancel,
    BookingModalDeny,
    BookingModalConfirm,
    BookingModalAllow,
    BookingModalOnlineEdit,
    BookingModalOrderNumber,
    BookingModalSendVoucher,
    LMap,
    LTileLayer,
    LMarker,
    category,
    fa,
    roundedButton,
    prices,
  },

  mixins: [formatter, buttons, bookingDeadline, viewPort],

  props: {
    booking: Object,
    anonymous: Boolean,
    actions: Object,
    isManager: {
      type: Boolean,
      required: true,
    },
    isUnlogged: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      show: false,
      alternateClass: "btn-disable btn",
      commonApi: new CommonApi(),
      leaflet: defaultLeaflet,
      bounds: null,
      refs: [],
      history: {
        fields: [
          {
            key: "date",
            label: this.$t("_date.default"),
          },
          {
            key: "type",
            label: this.$t("_action"),
          },
          {
            key: "user",
            label: this.$tc("_user_s", 2),
          },
        ],
        items: [],
      },
      hrs: {
        fields: [
          { key: "processKey", label: this.$t("_hrs_process_key") },
          { key: "processPassword", label: this.$t("_hrs_process_password") },
        ],
        items: [],
      },
      bookingId: this.booking.id,
      confirm: {
        status: false,
        message: null,
      },
      rooms: [],
      cancellationDeadline: null,
      confirmationDeadline: null,
      roomTypeError: false,
      btnActions: {
        main: {
          left: {
            allow: {
              display: false,
              class: "btn btn-enable",
              fa: "fas fa-check",
            },
            confirm: {
              display: false,
              class: "btn btn-validate orange-white",
              fa: "fas fa-check",
            },
            deny: {
              display: false,
              class: "btn btn-deny",
              fa: "fas fa-times",
            },
            online_validate: {
              display: false,
              class: "btn btn-validate-full orange-white",
              fa: "fa fa-check",
            },
            download_pdf: {
              display: false,
              class: "btn btn-pdf orange-white",
              fa: "fas fa-file-pdf",
            },
            download_ics: {
              display: false,
              class: "btn btn-ics orange-white",
              fa: "fas fa-file-download",
            },
            order_number: {
              display: false,
              class: "btn btn-order-number orange-white",
              fa: "fas fa-pencil-alt",
            },
            download_order_pdf: {
              display: false,
              class: "btn btn-pdf orange-white",
              fa: "fas fa-file",
            },
          },
          right: {
            edit: {
              display: false,
              fa: "fas fa-edit",
            },
            cancel: {
              display: false,
              fa: "fas fa-ban",
            },
          },
        },
        secondary: {
          duplicate: {
            display: false,
            fa: "fas fa-copy",
          },
          contactBBA: {
            display: false,
            fa: "fas fa-envelope",
          },
          send_voucher: {
            display: false,
            fa: "share-square",
          },
        },
      },
      modal: {
        name: null,
        props: {
          booking: this.booking,
          bookingId: this.booking.id,
          isOnline: this.booking.is_online,
          bookingStatus: this.booking.status,
          deadline: this.booking.cancellation_deadline,
          token: this.$route.params['token'],
          anonymous: this.anonymous
        },
      },
      stateFormation: false,
      anonymousPath: false,
      isEdit: this.$route.params['isEdit']
    };
  },

  created () {
    this.stateFormation = this.$store.getters['research/context'] === 'formation'
    this.initCustomFields();
    this.initBookingHistory();
    this.initHRSInformation();
    this.initRooms();
    this.initDeadlines();
    this.setBtnActions();
    this.leaflet.zoom = 10;
    this.leaflet.center = null;

    if (this.btnActions.main.left.download_pdf.display) {
      this.alternateClass = "btn-disable btn btnWidthLarger";
    }
  },

  methods: {
    setBtnActions() {
      // user is not logged : no action displayed if validation has been done
      if (this.isUnlogged && !Object.keys(this.actions).length) {
        for (let action of Object.values(this.btnActions.main.left)) {
          action.display = false;
        }
      }
      for (let [action, value] of Object.entries(this.actions)) {
        let done = false;

        for (let pos of Object.keys(this.btnActions["main"])) {
          // if user is not logged : only validation and download
          if (this.isUnlogged && pos === "right") break;

          if (Object.keys(this.btnActions.main[pos]).includes(action)) {
            this.btnActions["main"][pos][action]["display"] = value;
            done = true;
            break;
          }
        }

        // if user is not logged : only validation and download
        if (!this.isUnlogged && !done) {
          this.btnActions["secondary"][action]["display"] = value;
        }
      }
    },

    initCustomFields() {
      for (let customField of this.booking.booking_custom_fields) {
        if (customField.input_field) {
          let type = customField.input_field.type;
          let label = customField.input_field.label;
          let value = customField.value;

          /*switch (type) {
            case fieldTypes.NUMERIC:
            case fieldTypes.TEXT:
              value = customField.value || ''
              break
            case fieldTypes.DROP_DOWN_MENU:
            case fieldTypes.BOOLEAN:
              let selectedOption = customField.input_field.options.find((option) => {
                return option.value === customField.value
              })
              value = selectedOption ? selectedOption.label : ''
              break
          }*/

          this.refs.push({
            label: label,
            value: value,
          });
        }
      }
    },

    initBookingHistory() {
      this.history.items = [];

      let history = this.booking.booking_history.reverse();

      for (let action of history) {
        let type = getStatusTranslation(action.type);

        if (action.type === status.UNFINISHED_ONLINE_BOOKING) {
          if (history.find((item) => item.type === status.CONFIRMED))
            type = this.$t(
              `booking.status.${status.UNFINISHED_ONLINE_BOOKING}.alt`
            );
        }

        this.history.items.push({
          date: this.formatDateTime(action.date),
          type: type,
          user: action.user ? this.fullName(action.user) : "---",
        });
      }
    },

    initHRSInformation() {
      if (!this.booking.is_online) return;

      this.hrs.items = [
        {
          processKey: this.booking.hrs_process_key,
          processPassword: this.booking.hrs_process_password,
        },
      ];

      /*this.commonApi.getHrsBookingDetail(this.$route.params.id)
        .then(response => {
          if (response.data.reservationInformationRoomDetails) {
            for (let room of response.data.reservationInformationRoomDetails) {
              for (let key in room) {
                if (room.hasOwnProperty(key)) {
                  this.hrs.items.push({
                    key: key,
                    value: room[key]
                  })
                }
              }
            }
          }
        })*/
    },

    initRooms() {
      this.booking.hotel_rooms.forEach((room) => {
        if (["single", "double"].indexOf(room.type) === -1) {
          this.roomTypeError = true;
          return;
        }

        let addTraveller = (pos) => {
          travellers.push({
            name: this.fullName({
              firstName: room["customer" + pos + "_first_name"],
              lastName: room["customer" + pos + "_last_name"],
            }),
          });
        };

        let travellers = [];

        addTraveller(1);
        if (room.type === "double") addTraveller(2);

        let contact = {
          tel: {
            label: "tel",
            value: room.customer_mobile || null,
          },
          mail: {
            label: "mail",
            value: room.customer_email || null,
          },
        };

        let details = [];

        for (let key in contact) {
          if (contact.hasOwnProperty(key)) {
            if (contact[key].value) {
              details.push(`${contact[key].label} : ${contact[key].value}`);
            }
          }
        }

        if (details.length) travellers[0].contact = `(${details.join(", ")})`;

        let tempRoom = {
          rank: room.rank,
          type: room.type,
          bedType: room.bed_type,
          standardType: room.standard_type,
          travellers: travellers,
          price: room.hotelroom_price,
          crsReservationKey: room.crs_reservation_key
        };

        if (this.booking.is_online && !tempRoom.bedType) {
          tempRoom.description = room.description;
        }


        // if (!this.booking.is_online && !tempRoom.bedType) {
        //   tempRoom.description = room.description
        // }

        this.rooms.push(tempRoom);
      });

      this.rooms.sort((room1, room2) => {
        return room1.rank - room2.rank;
      });
    },

    initDeadlines() {
      let deadlines = this.getDeadlines(this.booking);
      this.cancellationDeadline = deadlines.cancellation;
      this.confirmationDeadline = deadlines.confirmation;
    },

    confirmAction(response) {
      this.confirm.status = response.success;
      this.confirm.message = response.message;
      this.$emit("update", this.bookingId);
    },

    downloadUrl(action) {
      let format = action.substring(action.indexOf("_") + 1);

      switch (format) {
        case "pdf":
        case "ics":
          return this.commonApi.downloadBookingUrl(this.bookingId, format);
        case "order_pdf":
          return this.commonApi.downloadOrderPdfUrl(this.bookingId);
      }
    },

    submitAction(action) {
      let redirect = (routeName, addParams = {}) => {
        let params = { id: this.booking.id };
        this.$router.push({
          name: routeName,
          params: { ...params, ...addParams },
        });
      };

      if (typeof action === "object" && action.name) action = action.name;

      let requireModal = false;
      let actionRef = action;

      switch (action) {
        case "duplicate":
          redirect("home_booking_duplicate", {
            isOnline: this.booking.is_online,
          });
          break;
        case "edit":
          if (this.isAnonymous) {
            redirect("public_booking_edit")
          } else {
            redirect("home_booking_edit");
          }
          break
        case "confirm_edit":
          if (this.booking.is_online && action == "edit") {
            action = "online-edit";
            actionRef = "online_edit";
            requireModal = true;
          } else if (
            this.booking.status === status.UNFINISHED_OFFLINE_BOOKING ||
            this.booking.status === status.DRAFT_OFFLINE_BOOKING
          ) {
            redirect("offline_booking_edit");
          } else {
            redirect("home_booking_edit");
          }
          break;
        case "contactBBA":
          redirect("home_message_create");
          break;
        case "order_number":
          action = "order-number";
          requireModal = true;
          break;
        case "send_voucher":
          action = "send-voucher";
          requireModal = true;
          break;
        case "allow":
        case "deny":
        case "confirm":
        case "online_validate":
        case "cancel":

          if (action === "online_validate" && this.booking.is_online) {
            actionRef = action;
            action = "confirm";
          }

          // in case of timeout deadline, redirect to contact BBA
          if (
            action === "cancel" &&
            this.cancellationThroughNewWindow(this.booking) &&
            !this.booking.is_online
          )
            redirect("home_message_create", { action: "cancel" });

          requireModal = true;
          break;
      }

      if (requireModal) {
        this.modal.name = `booking-modal-${action}`;

        this.$nextTick(() => {
          this.$refs.modal.$refs[actionRef].show();
        });
      }
    },

    initCancellationReasons (token) {
      this.commonApi.bookingCancellationReasonsPublic(token).then((response) => {
        this.$store.commit(
          'data/bookingCancellationReasons',
          response.data.data
        )
      })
    },

    calculatePricePerPersonPerNight(value) {
      let ret = null;

      if (value) {
        ret = value / this.booking.nb_nights / this.booking.nb_travellers;
      }

      return ret;
    },

    getWebsiteUrl(url) {
      let prefix = !/^http[s]?/.exec(url) ? "http://" : "";

      return prefix + url;
    },

    getBtnTitle(key) {
      if (
        key === "allow" &&
        this.booking.status === status.WAITING_FOR_MANAGER_POST_VALIDATION
      ) {
        return this.$t("_validate");
      } else if (
        key === "edit" &&
        this.booking.status === status.DRAFT_OFFLINE_BOOKING
      ) {
        return this.$t("_edit_draft");
      } else {
        return this.$t(this.buttons[key].title);
      }
    },
  },

  computed: {
    isAnonymous () {
      return this.anonymous || this.stateFormation;
    },

    displayMapOrRequests() {
      return this.displayMap || !this.isBookingComplete;
    },

    overallPrice() {
      return this.booking.price;
    },

    pricePerRoomPerNight() {
      return this.overallPrice / this.booking.nb_nights / this.nbRooms;
    },

    nbRooms() {
      return this.booking.single_rooms + this.booking.double_rooms;
    },

    isBookingComplete() {
      if (this.booking.is_online) {
        return true;
      } else {
        let isBookingComplete = [
          status.UNFINISHED_ONLINE_BOOKING,
          status.WAITING_FOR_MANAGER_POST_VALIDATION,
          status.WAITING_FOR_CUSTOMER_CONFIRMATION,
          status.CONFIRMED,
          status.FINISHED,
        ];

        let maybeComplete = [
          status.CHANGE_REQUEST,
          status.CANCEL_REQUEST,
          status.CANCELLED,
        ];

        if (isBookingComplete.indexOf(this.booking.status) !== -1) return true;

        if (maybeComplete.indexOf(this.booking.status) !== -1) {
          return this.booking.booking_history.some(function (history) {
            return isBookingComplete.indexOf(history.type) !== -1;
          });
        }

        return false;
      }
    },

    destinationWish() {
      let label = this.$t("booking.show.destination.wish");
      let value = null;
      let type = null;

      if (this.booking.desired_hotel) {
        value = this.formatHotelName(this.booking.desired_hotel);
        type = "booking.show.destination.favorite.hotel";
      } else if (this.booking.desired_location) {
        value = this.booking.desired_location.name;
        type = "booking.show.destination.favorite.location";
      } else {
        value = this.booking.desired_city;
      }

      if (type) value += " (" + this.$t(type) + ")";

      return {
        label: label,
        value: value,
      };
    },

    bookingType() {
      let ret = "booking.show.main_infos.is_";
      ret += this.booking.is_online ? "online" : (this.booking.is_contingent ? "contingent" : "offline");

      return this.$t(ret);
    },

    bookingStatus() {
      return getStatusTranslation(this.booking.status, this.isManager);
    },

    displayMap() {
      if (this.booking.hotel && this.isBookingComplete) {
        return this.booking.hotel.geo_lat && this.booking.hotel.geo_lng;
      } else return false;
    },

    managers() {
      if (this.isManager) return;
      if (!this.booking.managers) return;

      return {
        text: this.booking.managers
          .flatMap((manager) => this.fullName(manager))
          .join(", "),
        count: this.booking.managers.length,
      };
    },

    orderNumber () {
      let cieStore = this.anonymous ? this.booking.company : this.$store.getters["security/company"];

      if (this.anonymous) {
        return cieStore.order_number_required
          ? {
            label:
              cieStore.order_number_label,
            value: this.booking.order_number,
          }
          : null;
      } else {
        return cieStore.orderNumber && cieStore.orderNumber.required
          ? {
            label:
              cieStore.orderNumber.label ||
              this.$t('company.orderNumber.title'),
            value: this.booking.order_number,
          }
          : null;
      }
    }
  },

  watch: {
    booking() {
      // update data that has to be updated here
      this.initBookingHistory();
      this.setBtnActions();
    },
  },

  mounted() {
    if (this.isBookingComplete && this.displayMap) {
      this.$nextTick(() => {
        let latlng = L.latLng(
          this.booking.hotel.geo_lat,
          this.booking.hotel.geo_lng
        );

        let marker = new L.Marker(latlng, {
          draggable: false,
        });

        marker.addTo(this.$refs.imagesMap.mapObject);

        // recompute center and zoom
        this.$refs.imagesMap.mapObject.setZoomAround(latlng, 14);
        this.$refs.imagesMap.mapObject.panTo(latlng);
      });
    }
  },
};
</script>

<style scoped lang="scss">
.red {
  color: red;
}

.travellers {
  li {
    list-style-type: none;
  }
}
.alert-annul{
  padding-left: .5rem;
}
</style>
